// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  accessToken: "",
  isAuthenticated: false,
  refetch : "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },

    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setrefetch: (state, action) => {
      state.refetch = action.payload;
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.accessToken = "";
    },
  },
});

export const { saveUser, setAccessToken, setrefetch,logout } = authSlice.actions;

export default authSlice.reducer;
